export default __webpack_public_path__ + "static/media/algolia.12e3932a.png";